import ChevronIcon from "assets/icons/chevron.svg"
import styled from "styled-components"

import { CloseButtonProps, StyledCloseButton } from "./CloseButton"

const DownChevron = styled(ChevronIcon)`
  transform: rotate(180deg);
  stroke: ${(props) => props.theme.colors.dark} !important;
`

const ChevronCloseButton = ({
  onClose = () => {},
  size,
  showHoverStyles = false,
}: CloseButtonProps) => (
  <StyledCloseButton
    $showHoverStyles={showHoverStyles}
    aria-label="Close"
    onClick={onClose}
    size={size}
  >
    <DownChevron />
  </StyledCloseButton>
)

export default ChevronCloseButton
